<template>
    <div id="typeTable_main" :key="new Date().toLocaleDateString()">
        <div id="typeTable_wrapper">
            <table v-if="body" id="typeTable_table" class="ff-varela">
                <thead>
                    <tr>
                        <th class="fs-big bg-faded-dark" @click="toggleAll">
                            <div>
                                <i v-if="checkedAllState === 'a'" class="fas fa-check-square fc-main"></i>
                                <i v-if="checkedAllState === 'p'" class="fas fa-minus-square fc-main"></i>
                                <i v-if="checkedAllState === 'o'" class="fas fa-minus-square fc-main"></i>
                                <i v-if="checkedAllState === 'n'" class="far fa-square fc-main"></i>
                            </div>
                        </th>
                        <th class="fs-small bg-faded-dark">ID</th>
                        <th class="fs-small bg-faded-dark" v-for="header in headers">{{ header }}</th>
                        <th id="typeTable_table_stretcherTH" class="fs-small bg-faded-dark"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="bt-hover-dark" v-for="entity in table.entities" :class="checked[entity.id] ? 'bg-main-faded' : 'bg-white'">
                        <td class="fs-big">
                            <div @click="toggleBox(entity.id)">
                                <i v-if="checked[entity.id]" class="fas fa-check-square fc-main"></i>
                                <i v-else class="far fa-square fc-black"></i>
                            </div>
                        </td>
                        <td @click="toggleRow(entity.id)" class="fs-small" :class="checked[entity.id] ? 'fc-main id_underline' : 'fc-black'" >id={{ entity.id }}</td>
                        <template v-for="header in headers">
                            <td @click="toggleRow(entity.id)" class="fs-small fc-gray-dark ">
                                <type-table-cell :data="body[entity.id][header]"></type-table-cell>
                            </td>
                        </template>
                        <td @click="toggleRow(entity.id)" id="typeTable_table_stretcherTD" class=""></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
  import CustomCheckbox from '../miscellaneous/customCheckbox'
  import TypeTableCell from './typeTableCell'
  import { mixin as clickaway } from 'vue-clickaway';
  export default {
    name: 'typeTable',
    mixins: [ clickaway ],
    components: { TypeTableCell, CustomCheckbox },
    props: {
      table: {
        type: Object,
        default: [],
      }
    },
    data(){
      return{
        headers: [],
        body: {},
        checked: {},
      }
    },
    computed:{
        checkedAllState(){

          let checkCount = 0;
          let length = 0;

          for(let i in this.checked){
            length++;
            if(this.checked[i]){
              checkCount++;
            }
          }
          if(checkCount === 0){
            return 'n'
          }else if(checkCount === 1){
            return 'o'
          }else if(checkCount === length){
            return 'a'
          }else{
            return 'p'
          }
        }
    },
    methods: {
        processHeaders(){
          this.headers = [];
          console.log('processing headers...');
          if(this.table.entities.length){
            this.table.entities.forEach(entity => {
              if(entity.properties){
                entity.properties.forEach(property => {
                  if(!this.headers.includes(property.name)){
                    this.headers.push(property.name)
                  }
                })
              }
            });
          }
          if(this.headers.length){
            this.$store.commit('Kvs/set_typeHeaders', this.headers);
          }
        },
        processBody(){
          this.body = {};
          console.log('processing body...');
          if(this.table.entities.length){
            this.table.entities.forEach(entity => {
              this.body[entity.id] = {};
              this.$set(this.checked, entity.id, false);
              this.headers.forEach(header => {
                this.body[entity.id][header] = null;
                entity.properties.forEach(property => {
                  if(header === property.name){
                    this.body[entity.id][header] = property.value
                  }
                })
              })
            })
          }
        },
        refreshTable(){
          console.log('refreshing table...');
          this.processHeaders();
          this.processBody();
          this.toggleRow(this.$store.getters['Kvs/get_entity'].id);
        },
        toggleRow(entityId){
          for(let i in this.checked){
            this.checked[i] = false;
          }
          this.checked[entityId] = true;
          this.emitChecked();
        },
        toggleBox(entityId){
            this.checked[entityId] = !this.checked[entityId];
          this.emitChecked();
        },
        toggleAll(){
          let checkedOne = false;
          for(let i in this.checked){
            if(this.checked[i]){
              checkedOne = true;
            }
          }
          if(this.checkedAllState === 'p' || this.checkedAllState === 'n' || this.checkedAllState === 'o'){
            for(let i in this.checked){
              this.checked[i] = true;
            }
          }else{
            for(let i in this.checked){
              this.checked[i] = false;
            }
          }
          this.emitChecked();
        },
        getOneChecked(){
          let checkedId;
          let output;
          for(let entity in this.body){
            if(this.checked[entity]){
              checkedId = entity;
            }
          }
          for(let entity of this.table.entities){
            if(checkedId == entity.id){
              output = entity;
            }
          }
          if(this.checkedAllState === 'o') {
            this.$store.commit('Kvs/set_entity', output);
          }
          return output;
        },
        emitChecked(){
          this.$emit('checkedEntity', this.getOneChecked());
          this.$emit('checkedState', this.checkedAllState);
        }
    },
    watch: {
        table(){
          this.refreshTable();
        }
    },
    mounted(){
      this.refreshTable();
    }
  }
</script>

<style scoped>
    #typeTable_main{
        display: flex;
        margin-top: var(--layout-padding);
        width: calc(100% + var(--layout-padding) * 2);
        margin-left: calc(0px - var(--layout-padding));
        height: 100%;
        overflow: auto;
        position: relative;
    }
    #typeTable_wrapper{
        display: flex;
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 1;
    }
    #typeTable_table{
        border-spacing: unset;
        table-layout: auto;
        width: 100%;
    }
    #typeTable_table th{
        font-weight: unset;
        padding-left: 25px;
        padding-right: 25px;
        padding-top: 5px;
        padding-bottom: 5px;
        position: sticky;
        top: 0;
        border-bottom: 1px solid var(--color-gray);
        white-space: nowrap;
    }
    #typeTable_table td{
        border-bottom: 1px solid var(--color-gray);
        padding-left: 25px;
        padding-right: 25px;
        padding-top: 2px;
        padding-bottom: 2px;
        white-space: nowrap;
    }
    #typeTable_table th:first-child,
    #typeTable_table td:first-child{
        padding-left: 20px;
        padding-right: 0px;
    }
    #typeTable_table_stretcherTH,
    #typeTable_table_stretcherTD{
        width: 99%;
    }
    .id_underline{
        text-decoration: underline;
    }
</style>
